import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { CmsComponentTypeEnum } from '@models/enums';
import { LinkObject } from '@models/interfaces';

export namespace MultipleColumn {
  export const TypeEnum = CmsComponentTypeEnum.MULTIPLE_COLUMN;

  export interface ColumnConfig {
    image: { url: string; scale?: number };
    title: string;
    subtitle?:string;
    description: string;
    link?: LinkObject;
    bgColor?: string;
    hoverText?: string;
    hoverEffect?:boolean;
    animationType?:string;
    animationValue?:number
    counter?:number,
    showDecimals?:boolean
  }

  export interface ComponentConfig extends BaseComponentConfig {
    columns: ColumnConfig[];
    field_alignment?:string;
    field_animation?:boolean;
    anchor_id? : string;
  }
}
